import { useQuery } from "@tanstack/react-query";
import { http } from "../../lib/api";
import { ClipboardList, RefreshCcw } from "lucide-react";
import { SecurityAudit } from "../../components/SecurityAudit";

/**
 * Audit centrale (read-only) dei saloni. Mostra gli step di provisioning per
 * ciascun tenant. Nessun valore sensibile.
 */
export default function PlatformAudit() {
  const listQ = useQuery({
    queryKey: ["p-audit-salons"],
    queryFn: async () => (await http.get("/saloncentral/salons?include_archived=1")).data,
    refetchOnWindowFocus: false,
  });

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-6" data-testid="platform-audit-page">
      <div className="flex items-center gap-3 mb-4">
        <ClipboardList className="w-5 h-5" style={{ color: "var(--accent-green)" }} />
        <h1 className="font-serif text-3xl">Audit centrale</h1>
        <button onClick={() => listQ.refetch()} className="ml-auto text-xs underline" data-testid="pa-refresh">
          <RefreshCcw className="inline w-3 h-3 mr-1" />Aggiorna
        </button>
      </div>
      <p className="text-xs text-neutral-500 mb-4">
        Log degli step di provisioning per ogni tenant. Include record archiviati.
      </p>
      <div className="card-clean p-4 overflow-auto">
        <table className="w-full text-xs" data-testid="pa-table">
          <thead>
            <tr className="border-b" style={{ background: "var(--brand-bg)" }}>
              <th className="p-2 text-left">tenant_id</th>
              <th className="p-2 text-left">Slug</th>
              <th className="p-2 text-left">Env</th>
              <th className="p-2 text-left">Stato</th>
              <th className="p-2 text-left">Archived</th>
              <th className="p-2 text-left">Ultimi step</th>
            </tr>
          </thead>
          <tbody>
            {(listQ.data || []).map(s => (
              <tr key={s.tenant_id} className="border-b" data-testid={`pa-row-${s.tenant_id}`}>
                <td className="p-2 font-mono text-[10px]">{s.tenant_id}</td>
                <td className="p-2 font-mono">{s.slug}</td>
                <td className="p-2">{s.environment}{s.is_demo && <span className="ml-1 px-1 bg-amber-200">DEMO</span>}</td>
                <td className="p-2">{s.provisioning_state}</td>
                <td className="p-2">{s.archived ? "sì" : "—"}</td>
                <td className="p-2">
                  <div className="text-[10px] text-neutral-600 whitespace-pre-line">
                    {(s.steps || []).slice(-5).map(x => `• ${x.step} → ${x.status}`).join("\n") || "—"}
                  </div>
                </td>
              </tr>
            ))}
            {(listQ.data || []).length === 0 && !listQ.isLoading && (
              <tr><td colSpan="6" className="p-4 text-center text-neutral-500">Nessun record.</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <SecurityAudit />
    </div>
  );
}
